import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import HowDiscoWorks from "@/components/HowDiscoWorks";
import FooterSection from "@/components/FooterSection";
import { getAssetPath } from "@/utils/assetUtils";

const DriverLanding = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Log environment information
    console.log("Base URL:", import.meta.env.BASE_URL);
    console.log("Current environment:", import.meta.env.MODE);
    console.log("Is Production:", import.meta.env.PROD);
    console.log("Is Development:", import.meta.env.DEV);
    
    // Log asset paths for debugging
    console.log("Asset path example:", getAssetPath("disco_logo.png"));
    
    // Public directory info
    console.log("Public directory assets should be available at:", window.location.origin + "/");
    
    // Test direct asset loading from public
    const testImg = new Image();
    testImg.onload = () => console.log("✓ Direct public loading works!");
    testImg.onerror = () => console.error("✗ Direct public loading failed!");
    testImg.src = "/disco_logo.png";
    
    // Test logo assets
    const logoNames = [
      "Nova_Logo.png",
      "Insomniac_Logo.png",
      "Patriots_Logo.png",
      "Tao_Logo.png",
      "LN_Logo.png",
      "Wynn_Logo.png",
      "Liv_Logo.png",
      "Academy_Logo.png"
    ];
    
    logoNames.forEach(logo => {
      const img = new Image();
      img.onload = () => console.log(`✓ Logo loaded successfully: ${logo}`);
      img.onerror = () => console.error(`✗ Failed to load logo: ${logo}`);
      img.src = getAssetPath(logo);
    });
  }, []);

  return (
    <div className="min-h-screen bg-black text-foreground relative overflow-hidden">
      <Navbar />
      
      <main className="relative">
        <HeroSection />
        <HowDiscoWorks />
      </main>
      
      <FooterSection />
    </div>
  );
};

export default DriverLanding;